import React from "react";
import { Link } from "react-router-dom";

function SidebarMenu() {
  // Function to close the offcanvas after clicking a link
  const handleClose = () => {
    const offcanvasElement = document.getElementById("offcanvasPrimaryMenu");
    if (offcanvasElement) {
      const bsOffcanvas = window.bootstrap.Offcanvas.getInstance(offcanvasElement);
      if (bsOffcanvas) {
        bsOffcanvas.hide();
      }
    }
  };

  return (
    <div
      className="offcanvas offcanvas-start w-260"
      data-bs-scroll="true"
      tabIndex="-1"
      id="offcanvasPrimaryMenu"
    >
      <div className="offcanvas-header border-bottom h-70">
        <img src="assets/images/logo1.png" width="60" className="mt-3" alt="logo" />
        <button
          type="button"
          className="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>

      <div className="offcanvas-body">
        <nav className="sidebar-nav">
          <ul className="metismenu" id="sidenav">
            <li>
              <Link to="/dashboard" onClick={handleClose}>
                <div className="parent-icon">
                  <i className="material-icons-outlined">home</i>
                </div>
                <div className="menu-title">Home</div>
              </Link>
            </li>
             <li>
              <Link to="/takeaway" onClick={handleClose}>
                <div className="parent-icon">
                  <i className="fa fa-table" aria-hidden="true"></i>
                </div>
                <div className="menu-title">takeaway</div>
              </Link>
            </li>
            <li>
              <Link to="/table" onClick={handleClose}>
                <div className="parent-icon">
                  <i className="fa fa-table" aria-hidden="true"></i>
                </div>
                <div className="menu-title">Table</div>
              </Link>
            </li>
            <li>
              <Link to="/item" onClick={handleClose}>
                <div className="parent-icon">
                  <i className="fa fa-table" aria-hidden="true"></i>
                </div>
                <div className="menu-title">Menu</div>
              </Link>
            </li>
            <li>
              <Link to="/login" onClick={handleClose}>
                <div className="parent-icon">
                  <i className="fa fa-sign-in" aria-hidden="true"></i>
                </div>
                <div className="menu-title">Login</div>
              </Link>
            </li>
            <li>
              <Link to="/logout" onClick={handleClose}>
                <div className="parent-icon">
                  <i className="fa fa-sign-out" aria-hidden="true"></i>
                </div>
                <div className="menu-title">Signout</div>
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
}

export default SidebarMenu;
